import { required, email, regex, size } from 'vee-validate/dist/rules.js'
import { StringLengthValidate } from './stringLength'

const StringLength = {
  params: ['minimum', 'maximum'],
  validate: StringLengthValidate
}

export { required as NotEmpty, email as EmailAddress, StringLength, regex as RegularExpression, size as FileSize }
